import { format, isValid, parse } from 'date-fns';

const DATE_PARAM_FORMAT = 'yyyy-MM-dd';

/** Parses an exact zero-padded YYYY-MM-DD query param into a local Date, or returns undefined. */
const parseDateParam = (value: string | null | undefined): Date | undefined => {
  if (!value) return undefined;
  const date = parse(value, DATE_PARAM_FORMAT, new Date(0));
  if (!isValid(date) || format(date, DATE_PARAM_FORMAT) !== value) return undefined;
  return date;
};

/** Returns both dates when they are exact YYYY-MM-DD and check-out is later, otherwise undefined. */
export const parseDateRangeQueryParams = (checkIn: string | null | undefined, checkOut: string | null | undefined) => {
  const checkInDate = parseDateParam(checkIn);
  const checkOutDate = parseDateParam(checkOut);
  if (!checkInDate || !checkOutDate || checkInDate >= checkOutDate) return undefined;

  return {
    checkInDate,
    checkOutDate,
    checkIn: format(checkInDate, DATE_PARAM_FORMAT),
    checkOut: format(checkOutDate, DATE_PARAM_FORMAT),
  };
};

/** Reads check-in and check-out from the link: checkin, then startDate, and checkout, then endDate. */
export const resolveStayDateQueryParams = (helper: Readonly<{ getValueString: (keys: string) => string | undefined }>) => ({
  checkIn: helper.getValueString('checkin') || helper.getValueString('startDate'),
  checkOut: helper.getValueString('checkout') || helper.getValueString('endDate'),
});
